module.exports = __webpack_public_path__ + "img/wechat_icon.614d7a9e.png";